export const IslemTipi = {
  OLUSTURULDU: 1,
  ONAY_BEKLIYOR: 2,
  ONAYLANDI: 3,
  IPTAL_EDILDI: 4
} as const;

export const IslemAdi = {
  OLUSTURULDU: 'Oluşturuldu',
  ONAY_BEKLIYOR: 'Onay Bekliyor',
  ONAYLANDI: 'Onaylandı',
  IPTAL_EDILDI: 'İptal Edildi'
} as const;

export const EtkinlikTipi = {
  DIGER: 0,
  SEVK_EDILDI: 1,
  IPTAL_EDILDI: 2
} as const;

export const EtkinlikAdi = {
  DIGER: 'Diğer',
  SEVK_EDILDI: 'Sevk Edildi',
  IPTAL_EDILDI: 'İptal Edildi'
} as const;

export const getStatusById = (id: number): string => {
  const statusMap: Record<number, string> = {
    [IslemTipi.OLUSTURULDU]: IslemAdi.OLUSTURULDU,
    [IslemTipi.ONAY_BEKLIYOR]: IslemAdi.ONAY_BEKLIYOR,
    [IslemTipi.ONAYLANDI]: IslemAdi.ONAYLANDI,
    [IslemTipi.IPTAL_EDILDI]: IslemAdi.IPTAL_EDILDI
  };
  return statusMap[id] || '';
};

export const getIdByStatus = (status: string): number => {
  const idMap: Record<string, number> = {
    [IslemAdi.OLUSTURULDU]: IslemTipi.OLUSTURULDU,
    [IslemAdi.ONAY_BEKLIYOR]: IslemTipi.ONAY_BEKLIYOR,
    [IslemAdi.ONAYLANDI]: IslemTipi.ONAYLANDI,
    [IslemAdi.IPTAL_EDILDI]: IslemTipi.IPTAL_EDILDI
  };
  return idMap[status] || 0;
};

export const getActivityById = (id: number): string => {
  const activityMap: Record<number, string> = {
    [EtkinlikTipi.DIGER]: EtkinlikAdi.DIGER,
    [EtkinlikTipi.SEVK_EDILDI]: EtkinlikAdi.SEVK_EDILDI,
    [EtkinlikTipi.IPTAL_EDILDI]: EtkinlikAdi.IPTAL_EDILDI
  };
  return activityMap[id] || '';
};

export const getIdByActivity = (activity: string): number => {
  const idMap: Record<string, number> = {
    [EtkinlikAdi.DIGER]: EtkinlikTipi.DIGER,
    [EtkinlikAdi.SEVK_EDILDI]: EtkinlikTipi.SEVK_EDILDI,
    [EtkinlikAdi.IPTAL_EDILDI]: EtkinlikTipi.IPTAL_EDILDI
  };
  return idMap[activity] || 0;
};

export type IslemAdiType = typeof IslemAdi[keyof typeof IslemAdi];
export type ActivityAdiType = typeof EtkinlikAdi[keyof typeof EtkinlikAdi];

export const IslemAdiValues = Object.values(IslemAdi);
export const EtkinlikAdiValues = Object.values(EtkinlikAdi); 